<template>
  <div id="app">
    <notifications group="main"
      position="top center"
      :duration="4000"
      :max="1"
      :width="400"/>
    <id-header v-if="header" :login="this.login" @updateLogin="updateLogin"/>
    <router-view @updateLogin="updateLogin"/>
    <id-footer v-if="footer"/>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Logo from './components/Logo'
export default {
  name: 'App',
  data () {
    return {
      header: false,
      footer: false,
      login: false
    }
  },
  components : {
    'id-header' : Header, 
    'id-footer' : Footer,
    'id-logo' : Logo 
  },
  mounted () {
    if (this.$route.path != '/auth') {
      this.header = true
      this.footer = true
    }
    this.$cognito.isAuthenticated().then(session => {
      this.login = true
    }).catch(err => {
      this.login = false
    })
  },
  methods: {
    updateLogin(login) {
      this.login = login
    }
  }
}
</script>

<style>
  @import './assets/css/common.css'
</style>



// WEBPACK FOOTER //
// src/App.vue